import React from 'react';

const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-2xl'
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Simple Crown Logo */}
      <div className={`${sizeClasses[size]} flex-shrink-0`}>
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          {/* Crown Base */}
          <rect x="4" y="22" width="24" height="3" fill="#0078d4"/>

          {/* Crown Band */}
          <rect x="6" y="18" width="20" height="4" fill="#106ebe"/>

          {/* Crown Points */}
          <polygon points="6,18 8,12 10,18" fill="#0078d4"/>
          <polygon points="10,18 12,14 14,18" fill="#106ebe"/>
          <polygon points="14,18 16,8 18,18" fill="#0078d4"/>
          <polygon points="18,18 20,14 22,18" fill="#106ebe"/>
          <polygon points="22,18 24,12 26,18" fill="#0078d4"/>

          {/* Crown Jewels */}
          <circle cx="9" cy="15" r="1" fill="#ffd700"/>
          <circle cx="13" cy="16" r="1" fill="#ffd700"/>
          <circle cx="16" cy="13" r="1.2" fill="#ffd700"/>
          <circle cx="19" cy="16" r="1" fill="#ffd700"/>
          <circle cx="23" cy="15" r="1" fill="#ffd700"/>
        </svg>
      </div>

      {/* Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold text-blue-600 leading-tight ${textSizeClasses[size]}`}>
            BayesPrep
          </span>
          <span className={`text-xs text-blue-500 font-medium leading-tight ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
            Super Admin
          </span>
        </div>
      )}
    </div>
  );
};

// Alternative compact logo for small spaces
export const CompactLogo = ({ className = '' }) => {
  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      <div className="w-6 h-6">
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          {/* Compact Crown */}
          <rect x="6" y="20" width="20" height="2" fill="#0078d4"/>
          <rect x="7" y="17" width="18" height="3" fill="#106ebe"/>
          <polygon points="7,17 9,12 11,17" fill="#0078d4"/>
          <polygon points="11,17 13,14 15,17" fill="#106ebe"/>
          <polygon points="15,17 16,10 17,17" fill="#0078d4"/>
          <polygon points="17,17 19,14 21,17" fill="#106ebe"/>
          <polygon points="21,17 23,12 25,17" fill="#0078d4"/>
          <circle cx="16" cy="14" r="0.8" fill="#ffd700"/>
        </svg>
      </div>
      <span className="text-sm font-bold text-blue-600">SA</span>
    </div>
  );
};

// Logo variants for different contexts
export const LogoVariants = {
  // Full logo with text
  Full: (props) => <Logo {...props} showText={true} />,

  // Icon only
  Icon: (props) => <Logo {...props} showText={false} />,

  // Compact version
  Compact: CompactLogo,

  // Header version (optimized for navigation)
  Header: (props) => <Logo {...props} size="md" showText={true} className="text-white" />,

  // Sidebar version (smaller, compact)
  Sidebar: (props) => <Logo {...props} size="sm" showText={false} />
};

export default Logo;
